// @flow

import React from "react";
import { localize } from "redux-i18n";
import { View, ChartJS } from "@components";

type OwnProps = $Exact<{
  reportData: *,
  title?: string,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const AbsenceForPrevAndNextTenDays = ({ reportData, title, t }: Props) => {
  return (
    <ChartJS
      type="bar"
      title={title}
      data={{
        labels: ((reportData || {}).chartDaysData || []).map(([label]) => label),
        datasets: [
          {
            label: t("SHORT_TERM_ABSENCE"),
            data: ((reportData || {}).chartDaysData || []).map(([, shortTerm]) => shortTerm),
          },
          {
            label: t("LONG_TERM_ABSENCE"),
            data: ((reportData || {}).chartDaysData || []).map(([, , longTerm]) => longTerm),
          },
        ],
      }}
      options={{ height: 300, isStacked: true, wrapXAxisLabels: true }}
    />
  );
};

export default localize()(AbsenceForPrevAndNextTenDays);
